import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faEllipsisH,
  faArrowRight,
  faCheckCircle
} from '@fortawesome/pro-light-svg-icons';
import { Elements } from 'react-stripe-elements';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import SwipeableViews from 'react-swipeable-views';
import ViewIndicator from '../NewDash/ViewIndicator';
import Card from '../../artzu-ui/src/Card';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import TextField from '../../artzu-ui/src/TextField';
import SelectField from '../../artzu-ui/src/SelectField';
import Option from '../../artzu-ui/src/Option';
import AddCard from './AddCard';
import ChargeCard from './ChargeCard';
import Footer from './Footer';
import Loading from '../shared/Loading';
import Header from './Header';
import './payments.css';

class PayBalance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: this.props.amount,
      processing: false,
      addingCard: false,
      checkingOut: false,
      paymentAmount: this.props.amount.toFixed(2),
      partialAmount: this.props.amount.toFixed(2),
      editingPartial: false,
      partialError: '',
      cardIndex: 0,
      showReqFinModal: false,
      reqFinMsg: [],
      reqFinSent: this.props.currentUser.financingRequested,
      showPaymentError: false,
      paymentErrorMsg: '',
      checkoutSuccess: false,
      removingCard: false,
      missingCardError: '',
      loadingRemoval: false
    };
  }
  render() {
    const {
      amount,
      processing,
      addingCard,
      checkingOut,
      cardIndex,
      paymentAmount,
      editingPartial,
      partialError,
      showReqFinModal,
      reqFinMsg,
      reqFinSent,
      partialAmount,
      showPaymentError,
      paymentErrorMsg,
      checkoutSuccess,
      removingCard,
      missingCardError,
      loadingRemoval
    } = this.state;
    return (
      <Query query={GET_SOURCES} fetchPolicy="network-only">
        {({ loading, error, data, refetch }) => {
          if (loading) return <Loading size="3x" />;
          return (
            <div className="paying-balance">
              <Modal open={showReqFinModal}>
                <div className="request-financing">
                  {reqFinMsg.map(msg => (
                    <p>{msg}</p>
                  ))}
                  <div className="modal-buttons">
                    <Button
                      style={{ height: '32px' }}
                      padding="0"
                      label="Close"
                      color="#414141"
                      onClick={() =>
                        this.setState({
                          showReqFinModal: false,
                          reqFinMsg: []
                        })
                      }
                    />
                    <Button
                      style={{ height: '32px' }}
                      padding="0"
                      label={reqFinSent ? 'Cancel Request' : 'Request'}
                      color={reqFinSent ? 'red' : '#128DFF'}
                      onClick={() => this.requestFinancing()}
                    />
                  </div>
                </div>
              </Modal>
              {window.innerWidth >= 768 || /profile/.test(window.location.href) ? null : (
                <Header
                  className="paying-header"
                  title="Pay Balance"
                  back={!checkoutSuccess && !processing}
                  onClick={this.headerAction}
                />
              )}
              <Modal open={addingCard}>
                <Elements>
                  <AddCard
                    {...this.props}
                    refetch={refetch}
                    onClick={() =>
                      this.setState({ addingCard: false, cardIndex: 0 })
                    }
                    currentUser={this.props.currentUser}
                    primary={data.getSources.length === 0}
                  />
                </Elements>
              </Modal>
              {checkingOut ? (
                <Elements>
                  <ChargeCard
                    history={this.props.history}
                    source={data.getSources[cardIndex]}
                    holder={this.props.currentUser.fullName}
                    amount={paymentAmount}
                    showProcessing={() =>
                      this.setState({ processing: true })
                    }
                    processing={processing}
                    handlePayment={this.handlePayment}
                    showPaymentError={showPaymentError}
                    paymentErrorMsg={paymentErrorMsg}
                    checkoutSuccess={checkoutSuccess}
                    onClick={() =>
                      this.setState({
                        checkingOut: false,
                        showPaymentError: false,
                        paymentErrorMsg: ''
                      })
                    }
                  />
                </Elements>
              ) : null}
              {!addingCard && !checkingOut ? (
                <div className="balance-main">
                  {/profile/.test(window.location.href) ? null :
                  <div className="amount-display">
                    <p>Outstanding Balance</p>
                    <div className="balance-amount-display">
                      <h2>${amount.toFixed(2)}</h2>
                    </div>
                  </div>}
                  {/profile/.test(window.location.href) ? null : 
                  <div className="amount-display">
                    <p>Payment Amount</p>
                    <div className="partial-amount-display">
                      <div className="display-left">
                        {editingPartial ? (
                          <TextField
                            className="partial-input"
                            onChange={e => this.handlePartialInput(e)}
                            error={partialError}
                            width="75%"
                            value={partialAmount}
                            placeholder={amount.toFixed(2)}
                          />
                        ) : (
                          <h2>${paymentAmount}</h2>
                        )}
                        {editingPartial ? (
                          <div className="remaining-balance">
                            *Outstanding Balance $
                            {partialAmount - amount < 0
                              ? (partialAmount - amount).toFixed(2)
                              : '0.00'}
                          </div>
                        ) : (
                          <div
                            className="edit-amount-div"
                            onClick={() =>
                              this.setState({ editingPartial: true })
                            }>
                            Make Partial Payment
                          </div>
                        )}
                      </div>
                      {editingPartial ? (
                        <Button
                          className="edit-amount-button"
                          label="Save"
                          padding="0"
                          color="#414141"
                          onClick={this.updatePaymentAmount}
                        />
                      ) : null}
                    </div>
                  </div>}
                  <div className="choose-card-label">
                    <p>Payment Methods: </p>
                  </div>
                  {window.innerWidth >= 768 ? (
                    <div className="desktop-card-select">
                      <SelectField
                        className="select-field"
                        primaryColor="#414141"
                        width="70%"
                        disabled={data.getSources.length === 0}
                        prompt={
                          data.getSources[cardIndex]
                            ? `**** **** **** ${data.getSources[cardIndex].card.last4}   EXP ${data.getSources[cardIndex].card.expMonth}/${data.getSources[cardIndex].card.expYear}`
                            : 'Select Card'
                        }
                        onChange={this.handleIndexChange}>
                        {data.getSources.length > 0 &&
                          data.getSources.map((source, index) => {
                            return (
                              <Option
                                key={index}
                                label={`**** **** **** ${source.card.last4}   EXP ${source.card.expMonth}/${source.card.expYear}`}
                                value={index}
                                className="shift-option"
                              />
                            );
                          })}
                      </SelectField>
                      {data.getSources[cardIndex] ? (
                        <Button
                          width="20%"
                          disabled={loadingRemoval}
                          className="delete-card-button"
                          label="Delete Card"
                          color="#414141"
                          onClick={() =>
                            this.removeSource(
                              data.getSources[cardIndex].id,
                              refetch
                            )
                          }
                        />
                      ) : null}
                      <Button
                        label="Add Card"
                        color="#414141"
                        onClick={() =>
                          this.setState({
                            addingCard: true,
                            editingPartial: false
                          })
                        }
                      />
                    </div>
                  ) : (
                    <SwipeableViews
                      className="carousel swipa"
                      style={styles.root}
                      slideStyle={styles.slide}
                      onChangeIndex={this.handleIndexChange}
                      index={cardIndex}>
                      {data.getSources.map((source, index) => {
                        return (
                          <Card
                            className="cc-card"
                            key={index}
                            backgroundColor="#414141"
                            padding="0.5em 0.5em 0.5em 1em"
                            style={Object.assign(
                              {},
                              cardIndex === index
                                ? styles.slide1
                                : styles.slide2
                            )}>
                            {cardIndex === index && removingCard ? (
                              loadingRemoval ? (
                                <Loading size="3x" />
                              ) : (
                                <div className="card-display">
                                  <div className="card-options">
                                    <FontAwesomeIcon
                                      icon={faArrowRight}
                                      size="sm"
                                      onClick={() =>
                                        this.setState({
                                          removingCard: false
                                        })
                                      }
                                      style={{
                                        color: '#414141',
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        width: '10px',
                                        height: '10px'
                                      }}
                                    />
                                  </div>
                                  {source.primary ? null : (
                                    <Button
                                      label="Make Primary Card"
                                      style={{ borderColor: '#FFFFFF' }}
                                      primary
                                      fullWidth={true}
                                      className="make-primary-button"
                                      color="#414141"
                                      onClick={() =>
                                        this.changeDefaultSource(
                                          source.id,
                                          refetch
                                        )
                                      }
                                    />
                                  )}
                                  {source.primary ? null : (
                                    <p className="default-card-notice">
                                      *Primary cards will be used for
                                      automatic payments.
                                    </p>
                                  )}
                                  <div className="bottom-filler">
                                    <div
                                      className="delete-card"
                                      onClick={() =>
                                        this.removeSource(
                                          source.id,
                                          refetch
                                        )
                                      }>
                                      Delete Card
                                    </div>
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className="card-display">
                                <div className="card-options">
                                  <FontAwesomeIcon
                                    icon={faEllipsisH}
                                    onClick={() =>
                                      this.setState({ removingCard: true })
                                    }
                                    style={{
                                      color: '#414141',
                                      backgroundColor: 'white',
                                      borderRadius: '50%',
                                      width: '20px',
                                      height: '20px'
                                    }}
                                  />
                                </div>
                                <div className="default-card">
                                  {source.primary
                                    ? 'Primary Card'
                                    : 'Secondary Card'}
                                </div>
                                <p className="card-field-label">
                                  Card Holder Name
                                </p>
                                <div className="card-field-content">
                                  {source.owner.name}
                                </div>
                                <div className="space-between">
                                  <div className="column-flex">
                                    <span className="card-field-label">
                                      Card Number
                                    </span>
                                    <span className="card-field-content">
                                      **** **** **** {source.card.last4}
                                    </span>
                                  </div>
                                  <div className="column-flex">
                                    <span className="card-field-label">
                                      Expiry Date
                                    </span>
                                    <span className="card-field-content">
                                      {source.card.expMonth}/
                                      {source.card.expYear}
                                    </span>
                                  </div>
                                </div>
                                <div className="bottom-filler">
                                  {source.primary
                                    ? 'Automatic Payment Permitted'
                                    : ''}
                                </div>
                              </div>
                            )}
                          </Card>
                        );
                      })}
                      <Card
                        className="cc-card"
                        key={data.getSources.length + 1}
                        backgroundColor="#E6E6E6"
                        borderColor="#E6E6E6"
                        padding="0.5em 1em"
                        color="#414141"
                        width="72vw"
                        style={Object.assign({}, styles.slide3)}>
                        <div
                          className="add-card"
                          onClick={() =>
                            this.setState({
                              addingCard: true,
                              editingPartial: false
                            })
                          }>
                          <FontAwesomeIcon
                            icon={faPlus}
                            size="3x"
                            style={{ color: '#414141' }}
                          />
                          <p className="add-card-bold">
                            Add Credit/Debit Card
                          </p>
                          {data.getSources.length > 0 ? null : (
                            <p>
                              You currently have no card in the system.
                              Please add a card.
                            </p>
                          )}
                        </div>
                      </Card>
                    </SwipeableViews>
                  )}
                  {window.innerWidth >= 768 ? null : (
                    <ViewIndicator
                      dots={data.getSources.length + 1}
                      index={cardIndex}
                      className="viewing-dots"
                      active="#414141"
                      inactive="#dedede"
                      max={data.getSources.length + 1}
                      handleIndexChange={this.handleIndexChange}
                    />
                  )}
                  <p className="missing-card-msg">{missingCardError}</p>
                  {amount >= 1000 ? (
                    <div
                      className="request-financing-div"
                      onClick={this.handleFinancingRequest}>
                      {reqFinSent
                        ? 'Financing Requested'
                        : 'Request Financing'}
                    </div>
                  ) : null}
                  {/profile/.test(window.location.href) ? null : window.innerWidth >= 768 ? (
                    <div className="balance-footer-desktop">
                      <Button
                        className="balance-button"
                        padding="0"
                        label="Cancel"
                        color="#414141"
                        onClick={this.headerAction}
                      />
                      <Button
                        className="balance-button"
                        padding="0"
                        label="Next"
                        color="#414141"
                        onClick={() =>
                          this.setState(
                            data.getSources[cardIndex]
                              ? {
                                  checkingOut: true,
                                  missingCardError: '',
                                  editingPartial: false
                                }
                              : {
                                  missingCardError:
                                    'Please select a valid card.',
                                  editingPartial: false
                                }
                          )
                        }
                      />
                    </div>
                  ) : (
                    <div className="balance-footer">
                      <Button
                        className="balance-button"
                        padding="0"
                        label="Next"
                        color="#414141"
                        fullWidth={true}
                        onClick={() =>
                          this.setState(
                            data.getSources[cardIndex]
                              ? {
                                  checkingOut: true,
                                  missingCardError: '',
                                  editingPartial: false
                                }
                              : {
                                  missingCardError:
                                    'Please select a valid card.',
                                  editingPartial: false
                                }
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              ) : null}
              {/* <Footer action={this.footerAction()} label={this.footerLabel()} /> */}
            </div>
          );
        }}
      </Query>
    );
  }

  headerAction = () => {
    const { addingCard, checkingOut } = this.state;
    if (checkingOut) {
      this.setState({
        checkingOut: false,
        showPaymentError: false,
        paymentErrorMsg: '',
        missingCardError: ''
      });
    } else if (addingCard) {
      this.setState({
        addingCard: false,
        cardIndex: 0,
        missingCardError: ''
      });
    } else {
      this.props.togglePayingBalance();
    }
  };

  handleIndexChange = cardIndex => {
    this.setState({ cardIndex, removingCard: false });
  };

  handlePartialInput = event => {
    event.preventDefault();
    console.log(event.target.value);
    console.log(event.target.value.length === 0);
    console.log(
      event.target.value.length <= 9 &&
        /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/.test(event.target.value)
    );
    if (
      event.target.value.length === 0 ||
      (event.target.value.length <= 9 &&
        event.target.value.match(/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/))
    ) {
      this.setState({ partialAmount: event.target.value });
    }
  };

  updatePaymentAmount = () => {
    const { partialAmount } = this.state;
    if (parseFloat(partialAmount) && parseFloat(partialAmount) > 1) {
      this.setState({
        paymentAmount: parseFloat(partialAmount).toFixed(2),
        editingPartial: false
      });
    }
  };

  handlePayment = paymentResults => {
    if (paymentResults.errors) {
      this.setState({
        showPaymentError: true,
        paymentErrorMsg: paymentResults.errors,
        processing: false
      });
    } else if (paymentResults.transaction) {
      this.setState({
        amount: Math.abs(paymentResults.currentBalance).toFixed(2),
        paymentAmount: Math.abs(paymentResults.currentBalance).toFixed(2),
        checkoutSuccess: true,
        processing: false
      });
    }
  };

  handleFinancingRequest = () => {
    this.setState({
      showReqFinModal: true,
      reqFinMsg: [
        "We may accommodate a financing arrangement for your balance pending on our team's review of your request. The reviewing process can take up to 3-5 business days. Once the review process is complete, our team will notify you via email with their decision.",
        'Meanwhile your account will continue to be in negative balance until the full amount is paid.'
      ]
    });
  };

  requestFinancing = () => {
    this.props.client
      .mutate({
        mutation: REQUEST_FINANCING,
        variables: {
          amount: this.props.amount
        }
      })
      .then(res => {
        this.setState({
          showReqFinModal: false,
          reqFinSent: res.data.requestFinancing.requested,
          reqFinMsg: res.data.requestFinancing.success
            ? [
                `Your request has been submitted to our team.\nPlease allow 1-2 business days for processing.`
              ]
            : [`An error occurred, please try again.`]
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  removeSource = (sourceId, callback) => {
    this.setState({ loadingRemoval: true });
    this.props.client
      .mutate({
        mutation: REMOVE_SOURCE,
        variables: {
          sourceId
        }
      })
      .then(res => {
        if (res.errors) {
          console.log(res.errors);
        }
        callback();
        this.setState({
          removingCard: false,
          loadingRemoval: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  updateSource = (sourceId, updates, callback) => {
    this.setState({ loadingRemoval: true });
    this.props.client
      .mutate({
        mutation: UPDATE_SOURCE,
        variables: {
          sourceId,
          updates
        }
      })
      .then(res => {
        if (res.errors) {
          console.log(res.errors);
        }
        callback();
        this.setState({
          removingCard: false,
          loadingRemoval: false,
          cardIndex: 0
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  changeDefaultSource = (sourceId, callback) => {
    this.setState({ loadingRemoval: true });
    this.props.client
      .mutate({
        mutation: CHANGE_DEFAULT_SOURCE,
        variables: {
          sourceId
        }
      })
      .then(res => {
        if (res.errors) {
          console.log(res.errors);
        }
        callback();
        this.setState({
          removingCard: false,
          loadingRemoval: false,
          cardIndex: 0
        });
      })
      .catch(err => {
        console.log(err);
      });
  };
}

const REQUEST_FINANCING = gql`
  mutation requestFinancing($amount: Float!) {
    requestFinancing(amount: $amount) {
      success
      requested
    }
  }
`;

const REMOVE_SOURCE = gql`
  mutation RemoveSource($sourceId: String!) {
    removeSource(sourceId: $sourceId) {
      source {
        id
      }
      errors
    }
  }
`;

const UPDATE_SOURCE = gql`
  mutation UpdateSource($sourceId: String!, $updates: String!) {
    updateSource(sourceId: $sourceId, updates: $updates) {
      source {
        id
      }
      errors
    }
  }
`;

const CHANGE_DEFAULT_SOURCE = gql`
  mutation ChangeDefaultSource($sourceId: String!) {
    changeDefaultSource(sourceId: $sourceId) {
      source {
        id
      }
      errors
    }
  }
`;

const GET_SOURCES = gql`
  query getSources {
    getSources {
      id
      primary
      card {
        last4
        expMonth
        expYear
        country
      }
      owner {
        email
        name
      }
    }
  }
`;

const styles = {
  root: {
    padding: '0 12vw',
    width: '100vw',
    maxWidth: '100%'
  },
  slide: {
    width: '76vw',
    maxWidth: '337px',
    height: '45vw',
    maxHeight: '213px',
    padding: '0 2vw'
  },
  slide1: {
    width: '72vw',
    maxWidth: '337px',
    height: '45vw',
    maxHeight: '213px',
    color: '#fff',
    borderRadius: '12px',
    borderColor: '#414141',
    display: 'flex',
    flexDirection: 'column'
  },
  slide2: {
    width: '72vw',
    maxWidth: '337px',
    height: '45vw',
    maxHeight: '213px',
    opacity: '0.5',
    color: '#fff',
    borderRadius: '12px',
    borderColor: '#414141',
    display: 'flex',
    flexDirection: 'column'
  },
  slide3: {
    width: '72vw',
    maxWidth: '337px',
    height: '45vw',
    maxHeight: '213px',
    borderRadius: '12px',
    color: '#414141',
    display: 'flex',
    flexDirection: 'column'
  }
};

export default withApollo(PayBalance);



// WEBPACK FOOTER //
// ./src/components/NewPayments/PayBalance.js